import useQuery from '@shared/hooks/src/useQuery'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export default function usePatientEncounter(patientId, encounterId, options = {}) {
  return useQuery({
    queryKey: QK.patients.id(patientId).encounters.id(encounterId).details,
    queryFn: () => API.patients.id(patientId).encounters.id(encounterId).details(),
    ...options,
  })
}
